import {useNavigation} from '@react-navigation/native';
import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {AUTHENTICATED_ROUTES} from '../../../navigation/constants';
import {useIsLandscape} from '../../../utils';
import {Page} from '../../components';
import ConfigurePackageModal from '../Home/components/ConfigurePackageModal';
import ChangeGradeModal from '../Home/components/ChangeGradeModal';
import SubscriptionLandscapeModalController from './SubscriptionLandscapeModalController';
import NewPackageAnnouncementModal from '../Home/components/NewPackageAnnouncementModal';
import PackageList from '../Home/components/CardsList/PackageList';
import {
  basicPackageImage,
  individualSubjectPackageImage,
  proPackageImage,
} from '../../../assets/images';

const Subscription = () => {
  const navigation = useNavigation();
  const isLandscape = useIsLandscape();
  const [checkGrade, setCheckGrade] = useState();
  const [packageToBuy, setPackageToBuy] = useState();
  const [landscapeParams, setLandscapeParams] = useState();
  const [openPackageAnnouncement, setOpenPackageAnnouncement] = useState(false);
  const kids = useSelector((state) => state.general.kids);
  const selectedStudent = kids?.[0];

  const [isChooseIndividual] = useState(false);

  const individualPlanData = {
    title: 'Star Individual Subjects',
    heading: {
      titleText: 'Star Individual',
      subTitleText: 'Subjects',
    },
    subtitle:
      'Consider STAR PRO PACKAGE\nfor better value with affordable price',
    packageType: 'Individual',
    image: individualSubjectPackageImage,
    selectedStudent,
    onPress: (packageData) => {
      setCheckGrade(packageData);
    },
  };

  const basicPackageData = {
    title: 'Start Basic Package',
    heading: {
      titleText: 'Star Basic',
      subTitleText: 'Package',
    },
    subtitle: '1 CLASS PER WEEK FOR EACH SUBJECT',
    description: 'Intensive classes & free programmes are\nNOT INCLUDED',
    packageType: 'Package',
    image: basicPackageImage,
    selectedStudent,
    onPress: (packageData) => setCheckGrade(packageData),
  };

  const proPackageData = {
    title: 'Star Pro Package',
    heading: {
      titleText: 'Star Pro',
      subTitleText: 'Package',
    },
    subtitle: '2 CLASSES PER WEEK FOR EACH SUBJECT',
    description:
      'Intensive classes & free seminars\nfor faster improvement and better results',
    packageType: 'Pro',
    image: proPackageImage,
    selectedStudent,
    onPress: (packageData) => setCheckGrade(packageData),
  };

  const purchasePackages = [];

  purchasePackages.push(proPackageData);
  purchasePackages.push(basicPackageData);
  purchasePackages.push(individualPlanData);

  return (
    <>
      <Page header={{title: 'Buy/Renew Subscription', showDrawerAction: true}}>
        <PackageList data={purchasePackages} disabled />
      </Page>
      {Boolean(checkGrade) && (
        <ChangeGradeModal
          kidId={selectedStudent?.id}
          packageData={checkGrade}
          onClose={() => setCheckGrade(undefined)}
          onNextPressed={(paramsToSet) => {
            //if (isLandscape) {
            setPackageToBuy(checkGrade);
            //}
          }}
        />
      )}
      {Boolean(packageToBuy) && (
        <ConfigurePackageModal
          kidId={selectedStudent?.id}
          packageData={packageToBuy}
          onClose={() => setPackageToBuy(undefined)}
          onNextPressed={(paramsToSet) => {
            if (isLandscape) {
              setLandscapeParams(paramsToSet);
            } else {
              navigation.navigate(
                AUTHENTICATED_ROUTES.configurePackage.path,
                paramsToSet,
              );
            }
          }}
        />
      )}
      {Boolean(landscapeParams) && (
        <SubscriptionLandscapeModalController
          params={landscapeParams}
          handleClose={() => setLandscapeParams(undefined)}
        />
      )}
      {Boolean(openPackageAnnouncement) && (
        <NewPackageAnnouncementModal
          confirmSkip={isChooseIndividual}
          onClose={() => {
            if (isChooseIndividual) {
              setCheckGrade(individualPlanData);
            }
            setOpenPackageAnnouncement(false);
          }}
          handleOk={() => setOpenPackageAnnouncement(false)}
          handleConfirmProPackage={() => {
            setOpenPackageAnnouncement(false);
            setCheckGrade(proPackageData);
          }}
        />
      )}
    </>
  );
};

export default Subscription;
